// extracted by mini-css-extract-plugin
export default {"signupForm":"SignupForm_signupForm__XjkR6","sumbitButton":"SignupForm_sumbitButton__+7FEF"};